import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-flex-direction-column is-align-items-stretch p-0" }
const _hoisted_2 = { class: "grid p-2" }
const _hoisted_3 = {
  class: "is-size-7",
  title: "Cube identifier"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Next update in", -1)
const _hoisted_6 = { class: "is-flex is-align-items-center gap-2 owners" }
const _hoisted_7 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-align-items-flex-end"
}
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = {
  key: 0,
  class: "is-size-7 pr-2"
}
const _hoisted_10 = {
  key: 0,
  class: "table is-fullwidth has-background-light"
}
const _hoisted_11 = { class: "w-1/3" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_external_term = _resolveComponent("external-term")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_o_collapse = _resolveComponent("o-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: { name: 'CubeProject', params: { id: _ctx.project.clientPath } },
          class: "is-block has-text-weight-bold",
          title: "Open project"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.project.label), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.project.cubeIdentifier || (_ctx.project.sourceCube && _ctx.project.sourceCube.value)), 1)
      ]),
      _createElementVNode("div", null, [
        (_ctx.project.plannedNextUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.nextUpdateWarning(_ctx.project.plannedNextUpdate))
              }, _toDisplayString(_ctx.timeUntilNextUpdate(_ctx.project.plannedNextUpdate)), 3)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.project.maintainer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.project.maintainer.displayLabel), 1),
              (_ctx.project.creator && _ctx.project.creator.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.project.creator.name), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_o_tooltip, {
          class: "is-block",
          label: "More details"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_o_button, {
              "icon-left": "info-circle",
              variant: "white",
              size: "small",
              onClick: _ctx.toggleDetails
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_o_collapse, {
      animation: "slide",
      open: _ctx.detailsShown
    }, {
      trigger: _withCtx(() => []),
      default: _withCtx(() => [
        (_ctx.details)
          ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details.parts, (part) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: part.id.value,
                  class: "is-size-7"
                }, [
                  _createElementVNode("th", _hoisted_11, _toDisplayString(part.name), 1),
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.values, (value, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, [
                        _createVNode(_component_external_term, { resource: value }, null, 8, ["resource"]),
                        (index !== part.values.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, ", "))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (part.values.length === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}